<template>
  <div>
    <b-row>
      <b-col>
        <b-button
          :to="{ name: 'StatsEstablishments' }"
          variant="outline-primary">Liste des établissements</b-button>
      </b-col>
    </b-row>

    <b-table
      :fields="fieldsEstablishment"
      :items="establishments"
      small
      responsive="sm">
      <template
        slot="thead-top"
        slot-scope="data">
        <b-tr>
          <b-th
            variant="secondary"
            colspan="3">Etablissement</b-th>
          <b-th
            variant="secondary"
            colspan="1">Tendance</b-th>
        </b-tr>
      </template>
    </b-table>

    <b-table
      :fields="fieldsIndicators"
      :items="establishments"
      small
      responsive="sm">
      <template
        slot="thead-top"
        slot-scope="data">
        <b-tr>
          <b-th
            variant="secondary"
            colspan="4">Indicateur</b-th>
        </b-tr>
      </template>

      <template #cell(logistic)="row">
        <font-awesome-icon
          :icon="['fas', 'circle']"
          :style="{ color: row.item.logistic }"
          class=""/>
      </template>

      <template #cell(manage)="row">
        <font-awesome-icon
          :icon="['fas', 'circle']"
          :style="{ color: row.item.manage }"
          class=""/>
      </template>

      <template #cell(patgames)="row">
        <font-awesome-icon
          :icon="['fas', 'circle']"
          :style="{ color: row.item.patgames }"
          class=""/>
      </template>

      <template #cell(global)="row">
        <font-awesome-icon
          :icon="['fas', 'circle']"
          :style="{ color: row.item.global }"
          class=""/>
      </template>
    </b-table>

    <b-row>
      <b-col>
        <b-form-group>
          <b-input-group size="sm">
            <b-form-input
              id="commentsInput"
              v-model="comments"
              type="search"
              placeholder="Commentaires ou actions en cours"/>
            <b-input-group-append>
              <b-button
                :disabled="!comments"
                @click="comments = ''">Enregistrer</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-tabs content-class="mt-3">
      <b-tab
        title="Logistique"
        active>
        <b-table
          :fields="fieldsLogistic"
          :items="establishmentLogistic"
          small
          responsive="sm"/>
      </b-tab>
      <b-tab title="Outil de gestion">
        <b-table
          :fields="fieldsManage"
          :items="establishmentManage"
          small
          responsive="sm"/>
        <div>
          <b-form-group label="">
            <b-form-radio-group
              id="radio-group-manage"
              v-model="radioManage"
              :options="optionsManage"
              name="radio-options-manage"
            />
          </b-form-group>
        </div>
        <apexchart
          ref="barChartManage"
          :options="barManage.options"
          :series="barManage.series"
          type="bar"
          height="350/"/></b-tab>
      <b-tab title="PatGames">
        <b-table
          :fields="fieldsPatGames"
          :items="establishmentPatGames"
          small
          responsive="sm"/>
        <div>
          <b-form-group label="">
            <b-form-radio-group
              id="radio-group-patGames"
              v-model="radioPatGames"
              :options="optionsPatGames"
              name="radio-options-patGames"
            />
          </b-form-group>
        </div>
        <apexchart
          ref="barChartPatGames"
          :options="barPatGames.options"
          :series="barPatGames.series"
          type="bar"
          height="350/"/></b-tab>
    </b-tabs>


  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import VueApexCharts from 'vue-apexcharts';

const moment = require('moment');

export default {
  name: 'StatsEstablishment',
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      fieldsEstablishment: [
        {
          esta_name: {
            label: 'Nom',
            sortable: false,
            tdClass: 'align-middle',
            stickyColumn: true,
          },
        },
        {
          esta_postalcode: {
            label: 'Département',
            sortable: false,
            tdClass: 'align-middle',
          },
        },
        {
          off_name: {
            label: 'Offre',
            sortable: false,
            tdClass: 'align-middle',
          },
        },
        {
          trend: {
            label: 'Tendance',
            sortable: false,
            tdClass: 'align-middle',
          },
        },
      ],
      fieldsIndicators: [

        {
          logistic: {
            label: 'Logistique',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          manage: {
            label: 'Outil de gestion',
            sortable: false,
            tdClass: 'align-middle',
          },
        },
        {
          patgames: {
            label: 'PatGames',
            sortable: false,
            tdClass: 'align-middle',
          },
        },
        {
          global: {
            label: 'Global',
            sortable: false,
            tdClass: 'align-middle',
          },
        },
      ],
      fieldsLogistic: [
        {
          device_name: {
            label: 'N° tablette',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          last_syn: {
            label: 'Dernière synchro (J)',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
      ],
      fieldsManage: [
        {
          year_month: {
            label: 'Mois',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          nb_events: {
            label: 'Evenements créés',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          reports: {
            label: 'Cpts rendus terminés/total',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          external_sessions: {
            label: 'Séances externes',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
      ],
      fieldsPatGames: [
        {
          year_month: {
            label: 'Mois',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          nb_activities: {
            label: 'Activités',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          nb_patgames: {
            label: 'Séances PatGames',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          participants: {
            label: 'Nb de rés. touchés/total',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          time_patgames: {
            label: 'Temps(heures)',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
      ],
      comments: null,
      radioManage: 'nbEvents',
      optionsManage: [
        { text: 'Evénements créés', value: 'nbEvents' },
        { text: 'Cptes rendus terminés', value: 'finishedReports' },
        { text: 'Séances externes', value: 'externalSessions' },
      ],
      radioPatGames: 'nbActivities',
      optionsPatGames: [
        { text: 'Activités', value: 'nbActivities' },
        { text: 'Séances PatGames', value: 'patGamesSessions' },
        { text: 'Nb de résidents touchés', value: 'nbParticipants' },
        { text: 'Temps', value: 'time' },
      ],
      barManage: {
        options: {
          plotOptions: {
            bar: {
              horizontal: false,
            },
          },
          chart: {
            stacked: true,
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: true,
            },
          },
          responsive: [{
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0,
              },
            },
          }],
          xaxis: {
            type: 'category',
            categories: [],
          },
          yaxis: {
            title: {
              text: 'Evénements créés',
            },
          },
          fill: {
            opacity: 1,

          },
        },
        series: [],
      },
      barPatGames: {
        options: {
          plotOptions: {
            bar: {
              horizontal: false,
            },
          },
          chart: {
            stacked: true,
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: true,
            },
          },
          responsive: [{
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0,
              },
            },
          }],
          xaxis: {
            type: 'category',
            categories: [],
            tickPlacement: 'between',
          },
          yaxis: {
            title: {
              text: 'Activités',
            },
          },
          fill: {
            opacity: 1,

          },
        },
        series: [],
      },
    };
  },
  computed: {
    ...mapState({
      establishments: state => state.establishments.statsEstablishment,
      statsDetailsEstablishment: state => state.establishments.statsDetailsEstablishment,
      establishmentLogistic: state => state.establishments.establishmentLogistic,
      establishmentManage: state => state.establishments.establishmentManage,
      establishmentPatGames: state => state.establishments.establishmentPatGames,
    }),
  },
  watch: {
    radioManage: {
      handler(val) {
        const self = this;

        this.$refs.barChartManage.updateOptions({
          yaxis: {
            title: {
              text: self.optionsManage.find(e => e.value === val).text,
            },
          },
          xaxis: {
            categories: self.getMonths(),
          },
        });
        this.$refs.barChartManage.updateSeries([{ data: self.getSeries('manage', val) }], true);
      },
    },
    radioPatGames: {
      handler(val) {
        const self = this;

        this.$refs.barChartPatGames.updateOptions({
          yaxis: {
            title: {
              text: self.optionsPatGames.find(e => e.value === val).text,
            },
          },
          xaxis: {
            categories: self.getMonths(),
          },
        });
        this.$refs.barChartPatGames.updateSeries([{ data: self.getSeries('patgames', val) }], true);
      },
    },
    establishmentManage: {
      handler() {
        const self = this;
        this.$refs.barChartManage.updateOptions({
          yaxis: {
            title: {
              text: self.optionsManage.find(e => e.value === 'nbEvents').text,
            },
          },
          xaxis: {
            categories: self.getMonths(),
          },
        });
        this.$refs.barChartManage.updateSeries([{ data: this.getSeries('manage', 'nbEvents') }], true);
      },
    },
    establishmentPatGames: {
      handler() {
        const self = this;

        this.$refs.barChartPatGames.updateOptions({
          yaxis: {
            title: {
              text: self.optionsPatGames.find(e => e.value === 'nbActivities').text,
            },
          },
          xaxis: {
            categories: self.getMonths(),
          },
        });
        this.$refs.barChartPatGames.updateSeries([{ data: this.getSeries('patgames', 'nbActivities') }], true);
      },
    },
  },
  created() {
    // this.$store.dispatch('establishments/getStatsEstablishment')
  },
  mounted() {
    this.getStatsEstablishment(this.$router.currentRoute.params.id);
    this.getStatsDetailsEstablishment(this.$router.currentRoute.params.id);
  },
  methods: {
    ...mapActions({
      getStatsEstablishment: 'establishments/getStatsEstablishment',
      getStatsDetailsEstablishment: 'establishments/getStatsDetailsEstablishment',
    }),
    getMonths() {
      const months = [];

      for (let i = 4; i > 0; i -= 1) {
        const m = moment().subtract(i, 'month').format('MMMM');

        months.push(m.charAt(0).toUpperCase() + m.slice(1));
      }

      return months;
    },
    getSeries(barChart, option) {
      let series = [];

      if (barChart === 'manage') {
        if (option === 'nbEvents') {
          series = this.establishmentManage.map(e => e.nb_events);
        } else if (option === 'finishedReports') {
          series = this.establishmentManage.map(e => e.finished_reports);
        } else if (option === 'externalSessions') {
          series = this.establishmentManage.map(e => e.external_sessions);
        }
      } else if (barChart === 'patgames') {
        if (option === 'nbActivities') {
          series = this.establishmentPatGames.map(e => e.nb_activities);
        } else if (option === 'patGamesSessions') {
          series = this.establishmentPatGames.map(e => e.nb_patgames);
        } else if (option === 'nbParticipants') {
          series = this.establishmentPatGames.map(e => e.participants.split('/')[0]);
        } else if (option === 'time') {
          series = this.establishmentPatGames.map(e => e.time_patgames);
        }
      }

      series.pop();

      return JSON.parse(JSON.stringify(series.reverse()));
    },
  },
};
</script>
<style>

</style>
